import React from "react";
import { useNavigate } from "react-router-dom";
import TradeProjectManager from "../../components/trade/TradeProjectManager";
import { clearSession } from "../../utils/tradeApi";
import "./trade.css";

export default function TradeAdminProjects() {
  const navigate = useNavigate();

  function logout() {
    clearSession();
    navigate("/trade", { replace: true });
  }

  return (
    <main className="trade-page trade-project-page">
      <header className="trade-simple-header">
        <img className="trade-logo" src="/images/gemterra-logo-20260112-t.png" alt="Gemterra" />
        <div>
          <button className="trade-link-button" onClick={() => navigate("/trade/projects")}>Project list</button>
          <span>{localStorage.getItem("userEmail")}</span>
          <button className="trade-link-button" onClick={logout}>Sign out</button>
        </div>
      </header>
      <section className="trade-project-wrap trade-project-admin-page">
        <TradeProjectManager />
      </section>
    </main>
  );
}
